// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useLedgerEnd } from '@hooks/queries/ledger/useLedgerEnd';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { TransferInstruction } from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import InterfaceContract from '../../../../utils/InterfaceContract';

export const useTransferInstructions: () => UseQueryResult<
  InterfaceContract<TransferInstruction>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryTransferInstructions', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryTransferInstructions(offset!);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};
